<div class="card mb-2">
  <div class="card-body">
    <div class="card-title d-flex justify-content-between align-content-center">
      <h5>{{ data.id }}</h5>
      <a
        *ngIf="invoiceId"
        class="align-self-end"
        href="{{ baseUrl }}download/invoice-pdf/{{ invoiceId }}.pdf"
        target="_blank"
      >
        <button class="btn btn-secondary" translate type="button">DOWNLOAD_PDF</button>
      </a>
    </div>

    <div *ngIf="data.extra" class="card-text">
      <div class="row">
        <div class="col-6 col-md-4">
          <div class="pb-1">
            <lib-gung-text-input [(ngModel)]="data.extra.fh.ordernr" [gungTranslate]="'ORDER'" [renderStatic]="true">
            </lib-gung-text-input>
          </div>
          <div class="pb-1">
            <lib-gung-text-input
              [gungTranslate]="'FH_FAKTSTKOD'"
              [ngModel]="getStatus('FH_FAKTSTKOD_', data.extra.fh.faktstkod) | translate"
              [renderStatic]="true"
            ></lib-gung-text-input>
          </div>
          <div class="pb-1">
            <div class="form-group">
              <label class="mb-0 font-weight-bold" translate>LEFT_TO_PAY</label>
              <lib-price
                [currency]="data.extra.fh.valkod"
                [price]="data.extra.fh.vbfaktrest"
                class="form-control-plaintext p-0"
              ></lib-price>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-4">
          <div class="pb-1">
            <lib-gung-date-output [gungTranslate]="'INVOICE_DATE'" [value]="data.extra.fh.faktdat">
            </lib-gung-date-output>
          </div>
          <div class="pb-1">
            <lib-gung-date-output [gungTranslate]="'DUE_DATE'" [value]="data.extra.fh.faktffdat"></lib-gung-date-output>
          </div>
          <div class="pb-1">
            <div class="form-group">
              <label class="mb-0 font-weight-bold" translate>TOTAL_VALUE</label>
              <lib-price
                [currency]="data.extra.fh.valkod"
                [price]="data.extra.fh.vb_faktsum"
                class="form-control-plaintext p-0"
              ></lib-price>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-4">
          <div class="pb-1">
            <lib-gung-text-input
              [(ngModel)]="data.extra.fh.kundref2"
              [gungTranslate]="'CUSTOMER_REFERENCE'"
              [renderStatic]="true"
            ></lib-gung-text-input>
          </div>
          <div class="pb-1">
            <lib-gung-text-input
              [(ngModel)]="data.extra.fh.vref"
              [gungTranslate]="'OUR_REFERENCE'"
              [renderStatic]="true"
            >
            </lib-gung-text-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
